import { SIDE_NAV_LIGHT,SIDE_NAV_DARK, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'BuffBet';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const OAUTH2_REDIRECT_URI = env.OAUTH2_REDIRECT_URI
export const STEAM_AUTH_URL = API_BASE_URL + '/oauth2/authorize/steam?redir=' + OAUTH2_REDIRECT_URI
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = '/login'
export const PAYPAL_CLIENT_ID = env.PAYPAL_CLIENT_ID

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'pt',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
